<template>
    <div class="order">
        <van-nav-bar title="详情" left-arrow @click-left="$router.go(-1)" />

        <div v-if="list.length == 0">
            <van-empty description="暂无记录" />
        </div>
        <div v-else>
            <van-row v-for="item, index in list" :key="index"
                style="padding: 10px 10px;margin: 10px 10px;background-color: white;border-radius: 20px;">
                <van-col span="6">
                    <!-- 学生照片 -->
                    <van-image round width="80px" height="80px" :src="item.photo" />
                </van-col>
                <van-col span="18">
                    <!-- 学生姓名、刷卡时间 -->
                     <p style="font-size: 14px;color: grey;">设备名称: {{ item.device_name }}</p>
                    <p style="font-size: 14px;color: grey;">学生姓名: {{ item.name }}</p>
                    <p style="font-size: 14px;color: grey;">出入标识: {{ item.punch_type }}</p>
                    <p style="font-size: 14px;color: grey;">刷卡时间: {{ item.punch_time }}</p>
                    
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailList',
    components: {

    },
    data() {
        return {
            list: []
        }
    },
    mounted() {
        this.list = JSON.parse(this.$route.query.data)
        console.log(this.list)
    },
    methods: {

    },
    watch: {

    }
}
</script>

<style lang="less" scoped>
.order {
    background-color: #fafafa;
}
</style>
